var map = {
	"./0331_RWAForum2026_poster.jpg": 849,
	"./0515_AIResearchExchangeWorkshop_poster.png": 203,
	"./0607_MingHuaHsieh_lecture.jpg": 239,
	"./0610_AIFinTechForum2025.png": 797,
	"./0614金融中心論壇邀請函.jpg": 725,
	"./0801_JudithFan_lecture.jpg": 697,
	"./1006_ChuChengHsieh_lecture.jpg": 505,
	"./1017_OCOCOSDA2024.jpg": 774,
	"./2023玉山銀行校園商業競賽_活動照片.jpg": 777,
	"./2023玉山銀行校園商業競賽海報.jpg": 312,
	"./aiforum2025_pic1.png": 42,
	"./aiforum2025_pic2.jpg": 926,
	"./aiworkshop2026_pic1.jpg": 257,
	"./aiworkshop2026_pic2.jpg": 752,
	"./aiworkshop2026_pic3.jpg": 742,
	"./aiworkshop2026_pic4.jpg": 19,
	"./chatgpt論壇_pic1.jpg": 371,
	"./chatgpt論壇_pic2.jpg": 479,
	"./chatgpt論壇_pic3.jpg": 899,
	"./chatgpt論壇_pic4.jpg": 45,
	"./chuchenghsieh_pic1.jpg": 572,
	"./minghuahsieh_pic1.jpg": 864,
	"./ococosda2024_pic1.jpg": 846,
	"./rwaforum2026_group.jpg": 894,
	"./rwaforum2026_pic1.jpg": 909,
	"./rwaforum2026_pic2.jpg": 839,
	"./rwaforum2026_pic3.jpg": 807,
	"./第9屆經濟部國家產業創新獎QR code.jpg": 59,
	"./第9屆經濟部國家產業創新獎圖片.png": 478,
	"./第9屆經濟部國家產業創新獎簡章.pdf": 477,
	"./第9屆經濟部國家產業創新獎說明會報名表.docx": 956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;